import { pagedListWrapper, listWrapper } from '../../../api-client/wrappers'
import type { Starter } from '../../types/internal'
import type { LeaderboardItem, MemberRatingsItem } from './types'

export default {
  factory: ({ apiClient, version }) => {
    const leaderboard = pagedListWrapper<
      'id',
      LeaderboardItem,
      { slug: string }
    >()(apiClient, {
      path: _query => `/api/v${version}/ratings/leaderboard`,
      idKey: 'id'
    })

    const memberRatings = listWrapper<
      'id',
      MemberRatingsItem,
      { memberId: number | string }
    >(apiClient, {
      path: (_query, { memberId }) =>
        `/api/v${version}/ratings/member/${memberId}`,
      idKey: 'id'
    })

    return { leaderboard, memberRatings }
  }
} satisfies Starter
